import { render, staticRenderFns } from "./NewsCatagory.vue?vue&type=template&id=6cd517c6&scoped=true&"
import script from "./NewsCatagory.vue?vue&type=script&lang=js&"
export * from "./NewsCatagory.vue?vue&type=script&lang=js&"
import style0 from "./NewsCatagory.vue?vue&type=style&index=0&id=6cd517c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd517c6",
  null
  
)

export default component.exports